<!--
 * @Author: your name
 * @Date: 2021-08-28 16:40:58
 * @LastEditTime: 2021-09-10 17:38:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dc-hero-bump-website-front\src\views\Home\gameNews.vue
-->
<template>
  <div class="news">
    <div class="banner">
      <Top />
      <img src="../assets/pc/banner.png" alt="">

    </div>
    <div class="container">
      <div class="news-block">
        <router-view></router-view>
      </div>
      <div class="dl-block" v-if="!mobile" :class="{'dl-top':pathName}">
        <a href="https://herobump.onelink.me/ezuN/ef32f62" class="google"></a>
        <a href="https://herobump.onelink.me/ezuN/ef32f62" class="apple"></a>
        <ul class="link">
          <a href="https://www.facebook.com/HeroBumpMobile/"></a>
          <a
            href="https://www.youtube.com/channel/UCVbShNqWp2uFtNIToMmKh8Q"
          ></a>
          <a href="https://www.instagram.com/herobump/"></a>
          <a href="https://discord.gg/Un88zRjSbG"></a>
        </ul>
      </div>

    </div>
    <div class="footer">
      <Footer />
    </div>
  </div>
</template>
<script>
import Top from '@/components/Top'
import Footer from '@/components/footer'
import { userAgent } from '../utils/index.js'

export default {
  name: 'GameNews',
  components: {
    Top,
    Footer
  },
  data () {
    return {
      // pathName: true
    }
  },
 computed: {
    mobile () {
      return userAgent().mobile
    },
    pathName () {
      return this.$route.path === '/gameNews/newsDetail'
    }
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
@import url("../styles/mixin.less");
.fun(@multiple) {
.banner {
  width: 100%;
  position: relative;
  img{
    width: 100%;
  }
}
.container {
  // width: 1300PX * @multiple;
  display: flex;
  justify-content: center;
  // 清除浮动
  overflow: hidden;
  margin: 10PX * @multiple auto 0;
  margin-left: 180px;
  .news-block {
    float: left;
    width: 1024PX * @multiple;
    min-height: 400PX * @multiple;
  }
  .dl-block {
    float: left;
    width: 250PX * @multiple;
    height: 255PX * @multiple;
    margin-top: 170PX * @multiple;
    margin-left: 10PX * @multiple;
    background-color: #c2c2c2;
    border: solid 1PX #dbc952;
    a {
      display: block;
      width: 193PX * @multiple;
      height: 56PX * @multiple;
      margin: 30PX * @multiple auto 20PX * @multiple;
      &.apple {
        background: url("../assets/apple.png") no-repeat;
        background-size: 100%;
      }
      &.google {
        background: url("../assets/google.png") no-repeat;
        background-size: 100%;
      }
      &:hover{
        background-color: #000;
        border-radius: 10px;
        opacity: 0.8;
      }
    }
    .link {
      width: 100%;
      height: 62PX * @multiple;
      background:  url("../assets/pc/yellowbg2.png") no-repeat;
      .flex(@center);
      a {
        display: block;
        width: 40PX * @multiple;
        height: 40PX* @multiple;
        cursor: pointer;
        &:nth-child(1) {
          background: url("../assets/fb.png");
          background-size: 100% 100%;
        }
        &:nth-child(2) {
          background: url("../assets/youtube.png");
          background-size: 100% 100%;
        }
        &:nth-child(3) {
          background: url("../assets/ins.png");
          background-size: 100% 100%;
        }
        &:nth-child(4) {
          background: url("../assets/discord.png");
          background-size: 100% 100%;
        }
        &:hover{
          background-color:#fff;
          opacity:0.8;
          border-radius:100%
        }
      }
    }
  }
}
.footer{
  width: 100%;
  height: 460Px * @multiple;
  background: url('../assets/pc/footer-bg.png');
  background-size: 100%;
  position: relative;
  footer{
    position: absolute;
    bottom: 0;
  }
}
}
.fun(1);
@media screen and (max-width: 1500px) {
  .fun(0.65);
}
@media screen and (min-width: 1500px) {
  .dl-block{
    margin-top: 110px !important;
    .link{
      background-size: cover !important;
    }
  }
  .dl-top{
     margin-top: 144px !important;
  }
}
 @media screen and (max-width: 750px) {
  .banner {
  // height: 2.68rem;
    position: relative;
    img{
      height: 2.1rem;
    }
  }
  .dl-block {
    display: none;
  }
  .container {
   font-size: 0.24rem;
   width: 100%;
   margin: 0.2rem auto 0;
  .news-block {
    float: left;
    width: 100%;
    min-height: 5rem;
     }
   }
   .footer{
    width: 100%;
    height: 4.4rem;
    background:#fff;
   }
 }
</style>
